import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { GetPaymentAndTransactionRequest, GetPaymentAndTransactionResponse } from './useGetPaymentAndTransaction'


async function getSubOrdersByOrderId(
  data: GetPaymentAndTransactionRequest
): Promise<any> {
  try {
    return (await axiosInstance.get("/Transaction/GetSubOrdersByOrderId/" + data.orderId)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetSubOrdersByOrderId() {
  return useMutation<GetPaymentAndTransactionResponse, Error, GetPaymentAndTransactionRequest>((variables) =>
    getSubOrdersByOrderId(variables)
  );
}